import { LeaveFeedbackIcon } from '@repo/ui/LeaveFeedbackIcon'
import { OspreyAcademyIcon } from '@repo/ui/OspreyAcademyIcon'
import { OneToOneSupportIcon } from '@repo/ui/OneToOneSupportIcon'

export default [
  {
    label: 'Case management',
    urlSegment: 'case-management',
    clickable: true,
    children: [
      {
        label: 'Matters',
        urlSegment: 'matters',
        clickable: true,
        children: [
          {
            label: 'Matter workspace',
            urlSegment: 'matter-workspace',
            clickable: true
          },
          {
            label: 'Matter history',
            urlSegment: 'matter-history',
            clickable: true
          },
          {
            label: 'Document bundles',
            urlSegment: 'document-bundles', // Visibility controlled by enableBundledocs in useLookupsStore
            clickable: true
          },
          {
            label: 'Matter summary',
            urlSegment: 'matter-summary',
            clickable: true,
            children: [
              {
                label: 'Credit limit warnings',
                urlSegment: 'credit-limit-warnings',
                clickable: true
              }
            ]
          },
          {
            label: 'Key dates',
            urlSegment: 'key-dates',
            clickable: true
          },
          {
            label: 'Custom matter views',
            urlSegment: 'custom-matter-views',
            clickable: true
          },
          {
            label: 'Custom questionnaires',
            urlSegment: 'custom-questionnaires',
            clickable: true
          },
          {
            label: 'Custom data pages',
            urlSegment: 'custom-data-pages',
            clickable: true
          },
          {
            label: 'Document production',
            urlSegment: 'document-production',
            clickable: true
          },
          {
            label: 'Workflows',
            urlSegment: 'workflows',
            clickable: true
          },
          {
            label: 'Contract work forms',
            urlSegment: 'contract-work-forms',
            clickable: true
          },
          {
            label: 'Lexis forms',
            urlSegment: 'lexis-forms',
            clickable: true
          },
          {
            label: 'InfoTrack',
            urlSegment: 'infotrack',
            clickable: true
          },
          {
            label: 'Searchflow',
            urlSegment: 'searchflow',
            clickable: true
          },
          {
            label: 'Undertakings',
            urlSegment: 'undertakings',
            clickable: true
          },
          {
            label: 'Third-party forms',
            urlSegment: 'third-party-forms',
            clickable: true
          }
        ]
      },
      {
        label: 'Clients',
        urlSegment: 'clients',
        clickable: true,
        children: [
          {
            label: 'Client workspace',
            urlSegment: 'client-workspace',
            clickable: true
          },
          {
            label: 'Custom data pages',
            urlSegment: 'custom-data-pages',
            clickable: true
          },
          {
            label: 'Client portal',
            urlSegment: 'client-portal',
            clickable: false,
            children: [
              {
                label: 'Enable client access',
                urlSegment: 'enable-client-portal',
                clickable: true
              },
              {
                label: 'Enable associate access',
                urlSegment: 'enable-associate-portal',
                clickable: true
              }
            ]
          }
        ]
      },
      {
        label: 'Client / matter search',
        urlSegment: 'client-matter-search',
        clickable: true
      },
      {
        label: 'All key dates',
        urlSegment: 'all-key-dates',
        clickable: true
      },
      {
        label: 'Searchflow favourite products',
        urlSegment: 'searchflow-favourite-products',
        clickable: true
      },
      {
        label: 'Label printing',
        urlSegment: 'label-printing',
        clickable: true
      },
      {
        label: 'Conditional fees',
        urlSegment: 'conditional-fees',
        clickable: true
      },
      {
        label: 'Batch archive',
        urlSegment: 'batch-archive',
        clickable: true
      },
      {
        label: 'Contacts & organisations',
        urlSegment: 'contacts-organisations',
        clickable: true,
        children: [
          {
            label: 'Contact manager',
            urlSegment: 'contact-manager',
            clickable: true
          },
          {
            label: 'Organisation manager',
            urlSegment: 'organisation-manager',
            clickable: true
          }
        ]
      },
      {
        label: 'Web client enquiries',
        urlSegment: 'web-client-enquiries',
        clickable: true
      },
      {
        label: 'Questionnaires for review',
        urlSegment: 'questionnaires-for-review',
        clickable: true
      },
      {
        label: 'General file history',
        urlSegment: 'general-file-history',
        clickable: true
      },
      {
        label: 'General file history templates',
        urlSegment: 'general-file-history-templates',
        clickable: true
      }
    ]
  },
  {
    label: 'Time recording',
    urlSegment: 'time-recording',
    clickable: true,
    children: [
      {
        label: 'Time ledger',
        urlSegment: 'time-ledger',
        clickable: true
      },
      {
        label: 'Prospect time recording',
        urlSegment: 'prospect-time-recording',
        clickable: true
      },
      {
        label: 'Time sheets',
        urlSegment: 'time-sheets',
        clickable: true,
        children: [
          {
            label: 'New time sheet',
            urlSegment: 'new-time-sheet',
            clickable: true
          }
        ]
      },
      {
        label: 'Tick billed time',
        urlSegment: 'tick-billed-time',
        clickable: true
      },
      {
        label: 'Write off',
        urlSegment: 'write-off',
        clickable: true,
        children: [
          {
            label: 'View written off time',
            urlSegment: 'view-written-off-time',
            clickable: true
          }
        ]
      },
      {
        label: 'Print ledger',
        urlSegment: 'print-ledger',
        clickable: true,
        children: [
          {
            label: 'Running record of costs report',
            urlSegment: 'running-record-of-costs-report',
            clickable: true
          }
        ]
      },
      {
        label: 'Fees earner summary',
        urlSegment: 'fee-earner-summary',
        clickable: true
      },
      {
        label: 'Mark ups',
        urlSegment: 'mark-ups',
        clickable: true,
        children: [
          {
            label: 'Mark up time',
            urlSegment: 'mark-up-time',
            clickable: true
          }
        ]
      },
      {
        label: 'Transfer time',
        urlSegment: 'transfer-time',
        clickable: true,
        children: [
          {
            label: 'Transferred time',
            urlSegment: 'transferred-time',
            clickable: true
          }
        ]
      },
      {
        label: 'Phase limits',
        urlSegment: 'phase-limits',
        clickable: true
      }
    ]
  },
  {
    label: 'Compliance',
    urlSegment: 'compliance',
    children: [
      {
        label: 'Storage',
        urlSegment: 'storage',
        clickable: true
      },
      {
        label: 'Oaths',
        urlSegment: 'oaths',
        clickable: true
      },
      {
        label: 'Fee sharing & referrals',
        urlSegment: 'fee-sharing-referrals',
        clickable: true
      },
      {
        label: 'Introductions to third parties',
        urlSegment: 'introductions-third-parties',
        clickable: true
      },
      {
        label: 'Equality & diversity-breaches',
        urlSegment: 'equality-diversity-breaches',
        clickable: true
      },
      {
        label: 'GDPR',
        urlSegment: 'gdpr',
        clickable: false,
        children: [
          {
            label: 'Erasure requests',
            urlSegment: 'erasure-requests',
            clickable: true
          },
          {
            label: 'Erasure requests approval',
            urlSegment: 'erasure-requests-approval',
            clickable: true
          },
          {
            label: 'Data requests',
            urlSegment: 'data-requests',
            clickable: true
          },
          {
            label: 'Data requests approval',
            urlSegment: 'data-requests-approval',
            clickable: true
          }
        ]
      }
    ]
  },
  {
    label: 'Accounts',
    urlSegment: 'accounts',
    clickable: true,
    children: [
      {
        label: 'Client ledger',
        urlSegment: 'client-ledger',
        clickable: true,
        children: [
          {
            label: 'Allocate payments',
            urlSegment: 'allocate-payments',
            clickable: true
          },
          {
            label: 'Requisition',
            urlSegment: 'requisition',
            clickable: true
          },
          {
            label: 'Interest calculator',
            urlSegment: 'interest-calculator',
            clickable: true
          },
          {
            label: 'Deposit link',
            urlSegment: 'deposit-link',
            clickable: true
          },
          {
            label: 'Print',
            urlSegment: 'print',
            clickable: true
          },
          {
            label: 'Ledger summary',
            urlSegment: 'ledger-summary',
            clickable: true
          },
          {
            label: 'Credit limit warnings',
            urlSegment: 'credit-limit-warnings',
            clickable: true
          },
          {
            label: 'Auto posting',
            urlSegment: 'auto-posting',
            clickable: true
          },
          {
            label: 'Custom auto posting',
            urlSegment: 'custom-auto-posting',
            clickable: true
          }
        ]
      },
      {
        label: 'Billing',
        urlSegment: 'billing',
        clickable: false,
        children: [
          {
            label: 'Print bills',
            urlSegment: 'print-bills',
            clickable: true
          },
          {
            label: 'View billed time',
            urlSegment: 'view-billed-time',
            clickable: true
          },
          {
            label: 'Run batch aged debtor letters',
            urlSegment: 'run-batch-aged-debtor-letters',
            clickable: true
          },
          {
            label: 'Billing guide',
            urlSegment: 'billing-guide',
            clickable: true
          }
        ]
      },
      {
        label: 'Nominal ledgers',
        urlSegment: 'nominal-ledgers',
        clickable: false,
        children: [
          {
            label: 'Nominal ledgers',
            urlSegment: 'nominal-ledgers',
            clickable: true
          },
          {
            label: 'Nominal header',
            urlSegment: 'nominal-header',
            clickable: true
          },
          {
            label: 'Nominal SAC',
            urlSegment: 'nominal-sac',
            clickable: true
          },
          {
            label: 'Scheduled postings',
            urlSegment: 'scheduled-postings',
            clickable: true,
            children: [
              {
                label: 'Pending items',
                urlSegment: 'pending-items',
                clickable: true
              }
            ]
          },
          {
            label: 'Print current ledger',
            urlSegment: 'print-current-ledger',
            clickable: true
          },
          {
            label: 'Print all ledgers',
            urlSegment: 'print-all-ledgers',
            clickable: true
          },
          {
            label: 'Budgets',
            urlSegment: 'budgets',
            clickable: true
          },
          {
            label: 'Requisition',
            urlSegment: 'requisition',
            clickable: true
          }
        ]
      },
      {
        label: 'Purchase ledgers',
        urlSegment: 'purchase-ledgers',
        clickable: false,
        children: [
          {
            label: 'Purchase ledgers',
            urlSegment: 'purchase-ledgers',
            clickable: true
          },
          {
            label: 'Purchase header',
            urlSegment: 'purchase-header',
            clickable: true
          },
          {
            label: 'Allocate payments',
            urlSegment: 'allocate-payments',
            clickable: true
          },
          {
            label: 'Print',
            urlSegment: 'print',
            clickable: true
          },
          {
            label: 'Requisition',
            urlSegment: 'requisition',
            clickable: true
          }
        ]
      },
      {
        label: 'Banks & journals',
        urlSegment: 'banks-journals',
        clickable: false,
        children: [
          {
            label: 'Banks & journals',
            urlSegment: 'banks-and-journals',
            clickable: true
          },
          {
            label: 'Bank feeds',
            urlSegment: 'bank-feeds', // Visibility controlled by enableBankFeeds in useLookupsStore
            clickable: true
          },
          {
            label: 'Auto reconciliation',
            urlSegment: 'auto-reconciliation',
            clickable: true
          },
          {
            label: 'Requisitions',
            urlSegment: 'requisitions',
            clickable: true
          },
          {
            label: 'Cheque printing',
            urlSegment: 'cheque-printing',
            clickable: true
          }
        ]
      },
      {
        label: 'Employee claims',
        urlSegment: 'employee-claims',
        clickable: false,
        children: [
          {
            label: 'Expense claims',
            urlSegment: 'expense-claims',
            clickable: true
          },
          {
            label: 'Overtime claims',
            urlSegment: 'overtime-claims',
            clickable: true
          }
        ]
      }
    ]
  },
  {
    label: 'Reports',
    urlSegment: 'reports',
    clickable: false,
    children: [
      {
        label: 'Financial management',
        urlSegment: 'financial-management',
        clickable: false,
        children: [
          {
            label: 'Trial balance',
            urlSegment: 'trial-balance',
            clickable: true
          },
          {
            label: 'Profit & loss',
            urlSegment: 'profit-loss',
            clickable: true
          },
          {
            label: 'Period end',
            urlSegment: 'period-end',
            clickable: true
          },
          {
            label: 'Balance sheet',
            urlSegment: 'balance-sheet',
            clickable: true
          },
          {
            label: 'Year end',
            urlSegment: 'year-end',
            clickable: true
          },
          {
            label: 'Cash accounting VAT received',
            urlSegment: 'cash-accounting-vat-received',
            clickable: true
          },
          {
            label: 'Budget analysis',
            urlSegment: 'budget-analysis',
            clickable: true
          },
          {
            label: 'Aged creditors',
            urlSegment: 'aged-creditors',
            clickable: true
          },

          {
            label: 'Office receipts',
            urlSegment: 'office-receipts',
            clickable: true
          },
          {
            label: 'Office receipts - allocated',
            urlSegment: 'office-receipts-allocated',
            clickable: true
          }
        ]
      },
      {
        label: 'Financial management (cont.)',
        urlSegment: 'other-financial',
        clickable: false,
        children: [
          {
            label: 'Audit trail',
            urlSegment: 'audit-trail',
            clickable: true
          },
          {
            label: 'Audit trail (NL/PL)',
            urlSegment: 'audit-trail-nl-pl',
            clickable: true
          },
          {
            label: 'Purchase ledger allocations',
            urlSegment: 'purchase-ledger-allocations',
            clickable: true
          },
          {
            label: 'Purchase ledger balances',
            urlSegment: 'purchase-ledger-balances',
            clickable: true
          },
          {
            label: 'Suggested PL payments',
            urlSegment: 'suggested-pl-payments',
            clickable: true
          },
          {
            label: 'Unposted audit trail',
            urlSegment: 'unposted-audit-trail',
            clickable: true
          },
          {
            label: 'Credit limit warnings',
            urlSegment: 'credit-limit-warnings',
            clickable: true
          },
          {
            label: 'Current credit limit warnings',
            urlSegment: 'current-credit-limit-warnings',
            clickable: true
          },
          {
            label: 'Batch interest calculation',
            urlSegment: 'batch-interest-calculation',
            clickable: true
          },
          {
            label: 'Cheque report',
            urlSegment: 'cheque-report',
            clickable: true
          },
          {
            label: 'Multiple deposit ledger balances',
            urlSegment: 'multiple-deposit-ledger-balances',
            clickable: true
          }
        ]
      },
      {
        label: 'VAT Make Tax Digital (MTD)',
        urlSegment: 'vat-mtd',
        clickable: true
      },
      {
        label: 'ITSA Make Tax Digital (MTD)',
        urlSegment: 'itsa-mtd-report',
        clickable: true
      },
      {
        label: 'Client financial',
        urlSegment: 'client-financial',
        clickable: false,
        children: [
          {
            label: 'Aged debtors',
            urlSegment: 'aged-debtors',
            clickable: true
          },
          {
            label: 'Bills rendered',
            urlSegment: 'bills-rendered',
            clickable: true
          },
          {
            label: 'Cost transfer',
            urlSegment: 'cost-transfer',
            clickable: true
          },
          {
            label: 'Ledger balance',
            urlSegment: 'ledger-balance',
            clickable: true
          },
          {
            label: 'Client reconciliation',
            urlSegment: 'client-reconciliation',
            clickable: true
          },
          {
            label: 'Unpaid bills',
            urlSegment: 'unpaid-bills',
            clickable: true
          },
          {
            label: 'Unpaid disbursements',
            urlSegment: 'unpaid-disbursements',
            clickable: true
          },
          {
            label: 'Bills paid by fee earner',
            urlSegment: 'bills-paid-by-fee-earner',
            clickable: true
          },
          {
            label: 'Fees journal listing',
            urlSegment: 'fees-journal-listing',
            clickable: true
          },
          {
            label: 'Case cost',
            urlSegment: 'case-cost',
            clickable: true
          },
          {
            label: 'Case cost variance',
            urlSegment: 'case-cost-variance',
            clickable: true
          },
          {
            label: 'Client funds movement',
            urlSegment: 'client-funds-movement',
            clickable: true
          }
        ]
      },
      {
        label: 'Analysis',
        urlSegment: 'analysis',
        clickable: false,
        children: [
          {
            label: 'Live matters',
            urlSegment: 'live-matters',
            clickable: true
          },
          {
            label: 'New matters by user',
            urlSegment: 'new-matters-by-user',
            clickable: true
          },
          {
            label: 'New matters report',
            urlSegment: 'new-matters-report',
            clickable: true
          },
          {
            label: 'Archived matters',
            urlSegment: 'archived-matters',
            clickable: true
          },
          {
            label: 'Completed matters',
            urlSegment: 'completed-matters',
            clickable: true
          },
          {
            label: 'Key dates',
            urlSegment: 'key-dates',
            clickable: true
          },
          {
            label: 'Review periods',
            urlSegment: 'review-periods',
            clickable: true
          },
          {
            label: 'Fees analysis',
            urlSegment: 'fees-analysis',
            clickable: true
          },
          {
            label: 'Audit trail (case mgt)',
            urlSegment: 'audit-trail-case-mgt',
            clickable: true
          },
          {
            label: 'Fees analysis apportioned costs',
            urlSegment: 'fees-analysis-apportioned-costs',
            clickable: true
          },
          {
            label: 'Analysis of costs received',
            urlSegment: 'analysis-costs-received',
            clickable: true
          },
          {
            label: 'Fees analysis by time FE',
            urlSegment: 'fees-analysis-time-fe',
            clickable: true
          }
        ]
      },
      {
        label: 'Time',
        urlSegment: 'time',
        clickable: false,
        children: [
          {
            label: 'Time spent',
            urlSegment: 'time-spent',
            clickable: true
          },
          {
            label: 'Time spent summary',
            urlSegment: 'time-spent-summary',
            clickable: true
          },
          {
            label: 'Current month WIP/disbs',
            urlSegment: 'current-month-wip-disbs',
            clickable: true
          },
          {
            label: 'Percentage recovery',
            urlSegment: 'percentage-recovery',
            clickable: true
          },
          {
            label: 'Work in progress',
            urlSegment: 'work-in-progress',
            clickable: true
          },
          {
            label: 'WIP by time FE',
            urlSegment: 'wip-time-fe',
            clickable: true
          },
          {
            label: 'Attendance note by matter',
            urlSegment: 'attendance-note-matter',
            clickable: true
          }
        ]
      },
      {
        label: 'Miscellaneous reports',
        urlSegment: 'miscellaneous-reports',
        clickable: false,
        children: [
          {
            label: 'Contract work reports',
            urlSegment: 'contract-work-reports',
            clickable: true
          },
          {
            label: 'Spooled archive ledger',
            urlSegment: 'spooled-archive-ledger',
            clickable: true
          },
          {
            label: 'Nominal code report',
            urlSegment: 'nominal-code-report',
            clickable: true
          },
          {
            label: 'Nominal period report',
            urlSegment: 'nominal-period-report',
            clickable: true
          },
          {
            label: 'Top client - billing report',
            urlSegment: 'top-client-billing-report',
            clickable: true
          },
          {
            label: 'Top client - new matters',
            urlSegment: 'top-client-new-matters',
            clickable: true
          },
          {
            label: 'Top users - tasks ticked',
            urlSegment: 'top-users-tasks-ticked',
            clickable: true
          },
          {
            label: 'Top client - WIP report',
            urlSegment: 'top-clients-wip-report',
            clickable: true
          },
          {
            label: 'Top users - files opened',
            urlSegment: 'top-users-files-opened',
            clickable: true
          },
          {
            label: 'Top users - letters produced',
            urlSegment: 'top-users-letters-produced',
            clickable: true
          },
          {
            label: 'Auto billing report',
            urlSegment: 'auto-billing-report',
            clickable: true
          },
          {
            label: 'Client list',
            urlSegment: 'client-list',
            clickable: true
          },
          {
            label: 'Performance targets',
            urlSegment: 'performance-targets',
            clickable: true
          },
          {
            label: 'Last movement dates',
            urlSegment: 'last-movement-dates',
            clickable: true
          },
          {
            label: 'Restricted matters',
            urlSegment: 'restricted-matters',
            clickable: true
          },
          {
            label: 'Matter restriction audit',
            urlSegment: 'matter-restriction-audit',
            clickable: true
          }
        ]
      },
      {
        label: 'Custom reports',
        urlSegment: 'custom-reports',
        clickable: true
      }
    ]
  },
  {
    label: 'Supervisor',
    urlSegment: 'supervisor',
    clickable: false,
    children: [
      {
        label: 'Code setup',
        urlSegment: 'code-setup',
        clickable: false,
        children: [
          {
            label: 'Work types',
            urlSegment: 'work-types',
            clickable: true
          },
          {
            label: 'Activity codes',
            urlSegment: 'activity-codes',
            clickable: true,
            children: [
              {
                label: 'Add activity code',
                urlSegment: 'add-activity-code',
                clickable: true
              }
            ]
          },
          {
            label: 'Remuneration types',
            urlSegment: 'remuneration-types',
            clickable: true
          },
          {
            label: 'Fee earners',
            urlSegment: 'fee-earners',
            clickable: true
          },
          {
            label: 'Groups',
            urlSegment: 'groups',
            clickable: true
          },
          {
            label: 'Franchise categories',
            urlSegment: 'franchise-categories',
            clickable: true
          },
          {
            label: 'Standard text descriptions',
            urlSegment: 'standard-text-descriptions',
            clickable: true
          },
          {
            label: 'Attendance notes',
            urlSegment: 'attendance-notes',
            clickable: true
          },
          {
            label: 'Fee earner status',
            urlSegment: 'fee-earner-status',
            clickable: true
          },
          {
            label: 'Phases/tasks',
            urlSegment: 'phases-tasks',
            clickable: true
          },
          {
            label: 'Activities',
            urlSegment: 'activities',
            clickable: true
          },
          {
            label: 'Expenses',
            urlSegment: 'expenses',
            clickable: true
          },
          {
            label: 'Matters for review',
            urlSegment: 'matters-for-review',
            clickable: true
          }
        ]
      },
      {
        label: 'System setup',
        urlSegment: 'system-setup',
        clickable: false,
        children: [
          {
            label: 'Branches',
            urlSegment: 'branches',
            clickable: true
          },
          {
            label: 'Departments',
            urlSegment: 'departments',
            clickable: true
          },
          {
            label: 'Labels setup',
            urlSegment: 'labels-setup',
            clickable: true
          },
          {
            label: 'Matter archive details',
            urlSegment: 'matter-archive-details',
            clickable: true
          },
          {
            label: 'System settings',
            urlSegment: 'system-settings',
            clickable: true,
            children: [
              {
                label: 'Practice details',
                urlSegment: 'practice-details',
                clickable: true
              },
              {
                label: 'Third party data',
                urlSegment: 'third-party-data',
                clickable: true
              }
            ]
          },
          {
            label: 'Communication settings',
            urlSegment: 'communication-settings',
            clickable: true
          },
          {
            label: 'Users',
            urlSegment: 'users',
            clickable: true,
            children: [
              {
                label: 'Access templates',
                urlSegment: 'access-templates',
                clickable: true
              },
              {
                label: 'Request rights',
                urlSegment: 'request-rights',
                clickable: true
              },
              {
                label: 'Financial security setup',
                urlSegment: 'financial-security-setup',
                clickable: true
              },
              {
                label: 'Login manager',
                urlSegment: 'login-manager',
                clickable: true
              }
            ]
          },
          {
            label: 'Ledger view',
            urlSegment: 'ledger-view',
            clickable: true,
            children: [
              {
                label: 'Posting type view',
                urlSegment: 'posting-type-view',
                clickable: true
              }
            ]
          },
          {
            label: 'Configuration settings',
            urlSegment: 'configuration-settings',
            clickable: true,
            children: [
              {
                label: 'Designation',
                urlSegment: 'designation',
                clickable: true
              }
            ]
          },
          {
            label: 'Security groups',
            urlSegment: 'security-groups',
            clickable: true
          },
          {
            label: 'Email setup',
            urlSegment: 'email-setup',
            clickable: true
          },
          {
            label: 'Email sync configuration',
            urlSegment: 'email-sync-configuration',
            clickable: true
          },
          {
            label: 'Bank reconciliation status',
            urlSegment: 'bank-reconciliation-status',
            clickable: true
          },
          {
            label: 'Rebranding',
            urlSegment: 'rebranding',
            clickable: true
          },
          {
            label: 'Licence control',
            urlSegment: 'licence-control',
            clickable: true
          }
        ]
      },
      {
        label: 'Financial setup',
        urlSegment: 'financial-setup',
        clickable: false,
        children: [
          {
            label: 'Banks',
            urlSegment: 'banks',
            clickable: true
          },
          {
            label: 'Cheques',
            urlSegment: 'cheques',
            clickable: true,
            children: [
              {
                label: 'Cheque signatures',
                urlSegment: 'cheque-signatures',
                clickable: true
              },
              {
                label: 'Cheque templates',
                urlSegment: 'cheque-templates',
                clickable: true
              }
            ]
          },
          {
            label: 'Interest rates/bands',
            urlSegment: 'interest-rates-bands',
            clickable: true,
            children: [
              {
                label: 'Accrual periods',
                urlSegment: 'accrual-periods',
                clickable: true
              },
              {
                label: 'Add rate',
                urlSegment: 'add-rate',
                clickable: true
              },
              {
                label: 'Add band',
                urlSegment: 'add-band',
                clickable: true
              }
            ]
          },
          {
            label: 'Deposit accounts',
            urlSegment: 'deposit-accounts',
            clickable: true,
            children: [
              {
                label: 'Link to client - view',
                urlSegment: 'link-to-client-view',
                clickable: true
              }
            ]
          },
          {
            label: 'Periods',
            urlSegment: 'periods',
            clickable: true
          },
          {
            label: 'Currency',
            urlSegment: 'currency',
            clickable: true
          },
          {
            label: 'Countries',
            urlSegment: 'countries',
            clickable: true
          },
          {
            label: 'Time billing',
            urlSegment: 'time-billing',
            clickable: true,
            children: [
              {
                label: 'Create bill template',
                urlSegment: 'create-bill-template',
                clickable: true
              }
            ]
          },
          {
            label: 'Financial periods',
            urlSegment: 'financial-periods',
            clickable: true
          },
          {
            label: 'MTD ITSA HMRC setup',
            urlSegment: 'hmrc-itsa-setup',
            clickable: true
          },
          {
            label: 'MTD ITSA category mappings',
            urlSegment: 'hmrc-itsa-category-mapping',
            clickable: true
          }
        ]
      },
      {
        label: 'Case management setup',
        urlSegment: 'case-management-setup',
        clickable: false,
        children: [
          {
            label: 'Standard documents',
            urlSegment: 'standard-documents',
            clickable: true,
            children: [
              {
                label: 'Batch aged debtors letters',
                urlSegment: 'batch-aged-debtor-letters',
                clickable: true
              },
              {
                label: 'Lexis Forms config',
                urlSegment: 'lexis-forms-config',
                clickable: true
              }
            ]
          },
          {
            label: 'Email templates',
            urlSegment: 'email-templates',
            clickable: true
          },
          {
            label: 'Custom data pages',
            urlSegment: 'custom-data-pages',
            clickable: true
          },
          {
            label: 'Custom data page fields',
            urlSegment: 'custom-data-page-fields',
            clickable: true,
            children: [
              {
                label: 'Custom data page list fields',
                urlSegment: 'custom-data-page-list-fields',
                clickable: true
              },
              {
                label: 'View linked letters',
                urlSegment: 'view-linked-letters',
                clickable: true
              }
            ]
          },
          {
            label: 'Formulae',
            urlSegment: 'formulae',
            clickable: true
          },
          {
            label: 'Questionnaire design',
            urlSegment: 'questionnaire-design',
            clickable: false,
            children: [
              {
                label: 'Questionnaire administrator',
                urlSegment: 'questionnaire-administrator',
                clickable: true
              },
              {
                label: 'View questionnaires',
                urlSegment: 'view-questionnaires',
                clickable: true
              },
              {
                label: 'Published views in use',
                urlSegment: 'published-views-in-use',
                clickable: true
              }
            ]
          },
          {
            label: 'Workflows',
            urlSegment: 'workflows',
            clickable: true
          },
          {
            label: 'Tasks',
            urlSegment: 'tasks',
            clickable: true
          },
          {
            label: 'Expert types',
            urlSegment: 'expert-types',
            clickable: true
          },
          {
            label: 'Expertise areas',
            urlSegment: 'expertise-areas',
            clickable: true
          },
          {
            label: 'Key date types',
            urlSegment: 'key-date-types',
            clickable: true,
            children: [
              {
                label: 'Batch key date ticking',
                urlSegment: 'batch-key-date-ticking',
                clickable: true
              }
            ]
          },
          {
            label: 'Matter history',
            urlSegment: 'matter-history',
            clickable: false,
            children: [
              {
                label: 'Type',
                urlSegment: 'type',
                clickable: true
              },
              {
                label: 'Audit',
                urlSegment: 'audit',
                clickable: true
              }
            ]
          },
          {
            label: 'KPI details',
            urlSegment: 'kpi-details',
            clickable: true,
            children: [
              {
                label: 'KPI master users',
                urlSegment: 'kpi-master-users',
                clickable: true
              }
            ]
          },
          {
            label: 'Debt recovery',
            urlSegment: 'debt-recovery',
            clickable: true
          },

          {
            label: 'Bundle document settings',
            urlSegment: 'bundle-document-settings',
            clickable: true
          },
          {
            label: 'GDPR',
            urlSegment: 'gdpr',
            clickable: false,
            children: [
              {
                label: 'Retention policies',
                urlSegment: 'retention-policies',
                clickable: true
              },
              {
                label: 'Disposition',
                urlSegment: 'disposition',
                clickable: true
              }
            ]
          }
        ]
      },
      {
        label: 'Compliance',
        urlSegment: 'compliance',
        clickable: false,
        children: [
          {
            label: 'COLP/COFA list management',
            urlSegment: 'colp-cofa-list-management',
            clickable: true
          }
        ]
      },
      {
        label: 'Integrations',
        urlSegment: 'integrations',
        clickable: false,
        children: [
          {
            label: 'Searchflow setup',
            urlSegment: 'searchflow-setup',
            clickable: true,
            children: [
              {
                label: 'Searchflow bundles',
                urlSegment: 'searchflow-bundles',
                clickable: true
              }
            ]
          },
          {
            label: 'InfoTrack field mapping',
            urlSegment: 'infotrack-mapping',
            clickable: true
          },
          {
            label: 'Perfect Portal field defaults',
            urlSegment: 'perfectportal-defaults',
            clickable: true
          },
          {
            label: 'Coadjute tasks',
            urlSegment: 'coadjute-tasks',
            clickable: true
          },
          {
            label: 'FormEvo configuration',
            urlSegment: 'formevo-configuration',
            clickable: true
          }
        ]
      },
      {
        label: 'CRM',
        urlSegment: 'crm',
        clickable: false,
        children: [
          {
            label: 'CRM-AF1 additional rates',
            urlSegment: 'crm-af1-additional-rates',
            clickable: false,
            children: [
              {
                label: 'CRM police schemes',
                urlSegment: 'crm-police-schemes',
                clickable: true
              },
              {
                label: 'CRM police stations',
                urlSegment: 'crm-police-stations',
                clickable: true
              },
              {
                label: 'CRM prison law fees',
                urlSegment: 'crm-prison-law-fees',
                clickable: true
              },
              {
                label: 'CRM schemes',
                urlSegment: 'crm-schemes',
                clickable: true
              }
            ]
          },
          {
            label: 'Manage lists',
            urlSegment: 'manage-lists',
            clickable: true
          },
          {
            label: 'Reprint CRM 611 spreadsheet',
            urlSegment: 'reprint-crm611-spreadsheet',
            clickable: true
          },
          {
            label: 'CRM auto posting defaults',
            urlSegment: 'crm-auto-posting-defaults',
            clickable: true
          },
          {
            label: 'CRM list defaults',
            urlSegment: 'crm-list-defaults',
            clickable: true
          }
        ]
      },
      {
        label: 'Include documents',
        urlSegment: 'include-documents',
        clickable: true
      },
      {
        label: 'Portal setup',
        urlSegment: 'portal-setup',
        clickable: true,
        children: [
          {
            label: 'Associate access',
            urlSegment: 'associate-access',
            clickable: true
          },
          {
            label: 'Portal new page setup',
            urlSegment: 'portal-new-page-setup',
            clickable: true
          },
          {
            label: 'Access templates setup',
            urlSegment: 'access-templates-setup',
            clickable: true
          },
          {
            label: 'Document view setup',
            urlSegment: 'document-view-setup',
            clickable: true
          },
          {
            label: 'Configuration',
            urlSegment: 'configuration',
            clickable: true
          }
        ]
      },
      {
        label: 'Smart actions',
        urlSegment: 'smart-actions',
        clickable: true,
        children: [
          {
            label: 'Timesheet',
            urlSegment: 'timesheet',
            clickable: true,
            children: [
              {
                label: 'Pending data',
                urlSegment: 'pending-data',
                clickable: true
              }
            ]
          },
          {
            label: 'Auto billing',
            urlSegment: 'auto-billing',
            clickable: true
          },
          {
            label: 'Client & matter data import',
            urlSegment: 'client-matter-data-import',
            clickable: true
          },
          {
            label: 'Matter history note',
            urlSegment: 'matter-history-note',
            clickable: true
          }
        ]
      },
      {
        label: 'Report type',
        urlSegment: 'report-type',
        clickable: true
      }
    ]
  },
  {
    label: 'My account',
    urlSegment: 'my-account',
    clickable: false,
    children: [
      {
        label: 'Account settings',
        urlSegment: 'account-settings',
        clickable: true
      },
       {
        label: 'Expense claims',
        urlSegment: 'expense-claims',
        clickable: true
      },
      {
        label: 'Overtime claims',
        urlSegment: 'overtime-claims',
        clickable: true
      }
    ]
  },
  {
    label: 'Support',
    urlSegment: 'support',
    clickable: false,
    children: [
      {
        label: 'Osprey Academy',
        urlSegment: 'osprey-academy',
        clickable: true,
        href: 'https://support.ospreyapproach.com/',
        icon: <OspreyAcademyIcon />
      },
      {
        label: 'Request 1-1 support',
        clickable: true,
        icon: <OneToOneSupportIcon />,
        urlSegment: 'request-1-1-support'
      },
      {
        label: 'Leave feedback',
        urlSegment: 'leave-feedback',
        clickable: true,
        href: 'mailto:support@ospreyapproach.com?subject=Feedback%20on%20Osprey%20Approach',
        icon: <LeaveFeedbackIcon />
      }
    ]
  }
]
